import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TimeSimpleComponent} from './components/time-simple/time-simple.component';
import {TimepickerConfig, TimepickerModule} from 'ngx-bootstrap/timepicker';
import {getTimepickerConfig} from '@shared/modules/form/modules/time/functions/get-timepicker-config.function';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';


@NgModule({
  declarations: [TimeSimpleComponent],
  imports: [
    CommonModule,
    TimepickerModule.forRoot(),
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    TimeSimpleComponent
  ],
  providers: [{provide: TimepickerConfig, useFactory: getTimepickerConfig}]
})
export class TimeModule { }
